import React, { useState, useContext, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../layout/Content'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import InvoiceFooterStyle from './css/InvoiceFooterStyle'
import { appContext } from '../../../App'
import { invoiceControllerContext } from './InvoiceController'
import InvoiceListController from '../invoicelist/InvoiceListController'
import InvoiceItemController from '../invoiceitem/InvoiceItemController'
import ReceiptController from '../../receipt/receipt/ReceiptController'

function InvoiceFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const invoiceController = useContext(invoiceControllerContext)
  const { getInvoiceById, saveInvoice, warehouses } = invoiceController
  const [invoice, setInvoice] = invoiceController.invoice
  const [postOK, setPostOK] = useState(false)

  const onClickCheckout = async (e) => {
    //Will open another form or will render another view like pushing next page
    // InvoiceController component on the other hand is also unmounting
    // that's is the true in saveInvoice(invoice, true) parameter.

    const showMessageBox = (message) => {
      const onClick = async () => {
        setContent(<InvoiceListController />)
        ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
      }
      ReactDOM.render (
        <ModalWindow id='mw-parent' height='20' width='25' header='Invoice Not Found' footer={null}>
          <div className='messagebox'>
            <div className='messagebox-content'>
              { message }
            </div>
            <div className='button-container'>
              <button onClick={onClick} className='pospro-action-btn top-anchor'>Ok</button>
            </div>
          </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }

    // Check if invoice still exist first
    const inv = await getInvoiceById(app, invoice._id)
    if (inv) {
      if (inv.status === 'On Process' || inv.status === 'Unpaid') {
        const invoiceItem = await saveInvoice(app, invoice)
        if (invoiceItem) {
          const receipt_for = {
            item_name: 'Invoice',
            item: invoiceItem
          }
          setContent(<ReceiptController receipt_for={receipt_for}/>)
        }
      } else showMessageBox('Invoice either already Paid or Linked.')
    } else showMessageBox('Invoice file/record no longer exist.')
  }

  const onClickPostOnly = (e) => {
    invoice.action = 'post'
    saveInvoice(app, invoice).then(updated_invoice => {
      if (updated_invoice)
        //setContent(<InvoiceItemController invoiceItem={updated_invoice} />)
        setContent(<InvoiceItemController invoice={updated_invoice} />)
    })
  }

  const onClickInvoiceList = (e) => { setContent(<InvoiceListController />) }

  const onInvoiceListButtonFocus = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  useEffect(() => {
    setPostOK(invoice.customer_details.sold_to.trim() && invoice.invoice_particulars.length > 0)
  }, [invoice])

  const onChangeWarehouse = (e) => {
    setInvoice({
      ...invoice,
      warehouse: {
        id: warehouses.find(wh => wh.name === e.target.value)._id,
        name: warehouses.find(wh => wh.name === e.target.value).name
      }
    })
  }

  return (
    <ContentFooter>
      <div className="footer-container">
        <div className='warehouse-options-container'>
          <label style={{fontSize: '1rem'}}>Source Warehouse:</label>&nbsp;
          <select
            disabled={(postOK)}
            onChange={onChangeWarehouse}
            value={(invoice.warehouse) ? invoice.warehouse.name : ''}>
            {
              (warehouses) ?
                warehouses.map(wh => (
                  <option key={wh._id}>{wh.name}</option>
                ))
              : null
            }
          </select>
        </div>
        <div className='translist-button-container'>
          <button className="pospro-action-btn"
            id="invoice-list-btn"
            type="button"
            onClick={onClickInvoiceList}
            onFocus={onInvoiceListButtonFocus}>
            <FontAwesomeIcon icon='list-alt'/>&nbsp;Invoice's List
          </button>
          <button className={ !postOK ? 'pospro-action-btn disabled-button' : 'pospro-action-btn' }
            id="post-item-btn"
            type="button"
            disabled={!postOK}
            onClick={onClickPostOnly}>
            <FontAwesomeIcon icon='save'/>&nbsp;Post & Print...
          </button>
          <button className={ (!postOK) ? 'pospro-action-btn disabled-button' : 'pospro-action-btn' }
            id="checkout-btn"
            type="button"
            disabled={!postOK}
            onClick={onClickCheckout}>
            <FontAwesomeIcon icon='coins'/> <span>&nbsp;Checkout...</span>
          </button>
        </div>
      </div>
      <InvoiceFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(InvoiceFooter)